import { z } from "zod";
import {
  type SmartCreationDraft,
  type SmartCreationDraftContent,
  SmartCreationDraftContentSchema,
  SmartCreationDraftSchema,
  type SmartCreationObjectiveDecisions,
  SmartCreationObjectiveDecisionsSchema,
  type SmartCreationObjectiveRecommendation,
  SmartCreationObjectiveRecommendationSchema,
  type SmartCreationStrategyCapabilities,
  SmartCreationStrategyCapabilitiesSchema,
  type SmartCreationStrategyDecisions,
  SmartCreationStrategyDecisionsSchema,
  type SmartCreationStrategyDiagnostic,
  SmartCreationStrategyDiagnosticSchema,
  type SmartCreationStrategyRecommendation,
  SmartCreationStrategyRecommendationSchema,
} from "./smart-creation";
import {
  type SmartCreationReviewWorkspace,
  SmartCreationReviewWorkspaceSchema,
} from "./smart-creation-review";

/** Computed browser configuration. Revisions invalidate recommendations; they are never published plan versions. */
export interface SmartCreationBrowserDraft {
  id: string;
  shopId: string;
  status: "draft" | "preview_ready";
  revision: number;
  draft: SmartCreationDraft;
  objectiveRecommendation: SmartCreationObjectiveRecommendation | null;
  objectiveDecisions: SmartCreationObjectiveDecisions;
  strategyRecommendation: SmartCreationStrategyRecommendation | null;
  strategyDecisions: SmartCreationStrategyDecisions;
  strategyDiagnostics: SmartCreationStrategyDiagnostic[];
  strategyCapabilities: SmartCreationStrategyCapabilities;
  previewDraft: SmartCreationDraftContent | null;
  previewForRevision: number | null;
  reviewWorkspace: SmartCreationReviewWorkspace | null;
  createdAt: string;
  updatedAt: string;
}
export const SmartCreationBrowserDraftSchema: z.ZodType<
  SmartCreationBrowserDraft,
  z.ZodTypeDef,
  unknown
> = z
  .object({
    id: z.string().uuid(),
    shopId: z.string().uuid(),
    status: z.enum(["draft", "preview_ready"]),
    revision: z.number().int().positive(),
    draft: SmartCreationDraftSchema,
    objectiveRecommendation: SmartCreationObjectiveRecommendationSchema.nullable(),
    objectiveDecisions: SmartCreationObjectiveDecisionsSchema,
    strategyRecommendation: SmartCreationStrategyRecommendationSchema.nullable(),
    strategyDecisions: SmartCreationStrategyDecisionsSchema,
    strategyDiagnostics: z.array(SmartCreationStrategyDiagnosticSchema).max(100),
    strategyCapabilities: SmartCreationStrategyCapabilitiesSchema,
    previewDraft: SmartCreationDraftContentSchema.nullable(),
    previewForRevision: z.number().int().positive().nullable(),
    reviewWorkspace: SmartCreationReviewWorkspaceSchema.nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
  })
  .strict();
